angular.module('rjmNg.directives').directive "datePickerDropdown", [
  "$timeout"
  "$compile"
  "$document"
  (
    $timeout
    $compile
    $document
  ) ->
    restrict: "A"
    link: (scope, element, attr) ->
      datePickerVisible = false

      # Create date-picker element
      template = """
                 <date-picker
                   input-date='#{attr.inputDate}'
                   week-start-day='#{attr.weekStartDay}'
                   format='#{attr.format}'>
                 </date-picker>
                 """
      datePickerElement = angular.element(template)
      $compile(datePickerElement)(scope)

      element.addClass('date-picker-wrapper')
      $timeout () ->
        element.append(datePickerElement)

      _toggleRjDataPicker = (event) ->
        # Toggle if clicked on parent element or selected day
        dateList = element[0].querySelectorAll(".date-picker__day-list")[0]
        datePicker = element[0].querySelectorAll(".date-picker")[0]
        if element[0] is event.target or
           (element[0].contains(event.target) and not datePicker.contains(event.target)) or
           dateList.contains(event.target)
             datePickerVisible = not datePickerVisible
             switch datePickerVisible
              when true
                element.addClass('date-picker-wrapper--opened')
              when false
                element.removeClass('date-picker-wrapper--opened')

      _clickOutsideRjDatePicker = (event) ->
        if datePickerVisible and
          not (element[0] is event.target or
               element[0].contains(event.target))
                 datePickerVisible = false
                 element.removeClass('date-picker-wrapper--opened')

      element.on('click', _toggleRjDataPicker)

      $document.on("click", _clickOutsideRjDatePicker)

      _cleanUp = () ->
        $document.off('click', _clickOutsideRjDatePicker)
        element.off('click', _toggleRjDataPicker)
        return

      scope.$on('$destroy', _cleanUp)
]
